import { get } from 'helpers/api';

export const SET_FILE_ID = 'SET_FILE_ID';
export function setFile(id) {
  return { id, type: SET_FILE_ID };
}

export const UPDATE_IMPORT_STATUS = 'UPDATE_IMPORT_STATUS';
export function updateImportStatus(status) {
  return { status, type: UPDATE_IMPORT_STATUS };
}

function onImportComplete() {
  location.reload();
}

export function refreshImportStatus(expectedStatuses) {
  return (dispatch, getState) => {
    const runStatusPath = getState().paths.runStatusPath;
    get(runStatusPath).then((response) => {
      const { complete, total } = response;
      if (expectedStatuses.includes(response.status)) {
        onImportComplete();
      } else {
        let status = 0;
        if (total > 0 && complete > 0) {
          status = (parseFloat(complete) / parseFloat(total)) * 100;
        }
        dispatch(updateImportStatus(parseInt(status)));
      }
    });
  };
}
